import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

interface UnderMaintenanceModeModel {
  isActive: boolean;
  title: string;
  message: string;
}

export type UnderMaintenanceState = {
  underMaintenanceMode: UnderMaintenanceModeModel;
};

const initState: UnderMaintenanceState = {
  underMaintenanceMode: {
    isActive: false,
    title: null,
    message: null,
  },
};

export const useUnderMaintenance = createStore({
  name: 'under-maintenance',
  devtools: true,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setUnderMaintenanceMode: handler('underMaintenanceMode'),
  };
});
